import { Theme } from '@emotion/react';
import { SxProps } from '@mui/system';

const styles = {
  container: {
    flexDirection: 'column',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'secondary.main',
    p: '16px',
    borderRadius: '8px',
    mb: '8px',
  },
  headerLeftContainer: {
    display: 'flex',
    backgroundColor: 'chartColors.green251',
    p: '8px',
    width: '380px',
    borderRadius: '8px',
    alignItems: 'center',
  },
  headerRightContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    color: 'grey.800',
    fontWeight: '600',
    fontSize: '14px',
    ml: '10px',
  },
  counterOfferText: {
    fontSize: 16,
    fontWeight: '600',
    color: 'primary.main',
  },
  dateBoxGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2,1fr)',
    columnGap: '10px',
  },
  selectRequestText: {
    fontSize: 14,
    fontWeight: '600',
    color: 'common.counterRed',
    maxWidth: '70%',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
